export default "__VITE_ASSET__C4cv9ZyD__"